import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=b6e0d67e&scoped=true"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=b6e0d67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e0d67e",
  null
  
)

export default component.exports